import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=23e60ee6&"
import script from "./Full.vue?vue&type=script&lang=ts&"
export * from "./Full.vue?vue&type=script&lang=ts&"
import style0 from "./Full.vue?vue&type=style&index=0&id=23e60ee6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports